module.exports = __webpack_public_path__ + "static/media/has-containers-empty.ced9fcc0.svg";